const SvgSecure2 = (props) => (
  <>
    <path
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
      d="M96 248v-64M96 16v72M96 328v-64M96 104v64M96 16h80c0 41.7-31.58 75.97-72.02 80M96 16H16c0 41.7 31.58 75.97 72.02 80M103.98 176c40.44-4.03 72.02-38.3 72.02-80h-72M88 96H16c0 41.7 31.58 75.97 72.02 80M103.98 256c40.44-4.03 72.02-38.3 72.02-80h-72M88.02 256C47.58 251.97 16 217.7 16 176h72M88 256H16c0 41.7 31.58 75.97 72.02 80M103.98 336c40.44-4.03 72.02-38.3 72.02-80h-72"
    />
    <path
      d="M103.98 95.6c0 .13.02.26.02.4M96 104c4.42 0 8-3.58 8-8M96 88c4.28 0 7.77 3.37 7.98 7.6M88.02 95.6c.21-4.23 3.7-7.6 7.98-7.6M96 104c-4.42 0-8-3.58-8-8M88.02 95.6c0 .13-.02.26-.02.4M103.98 175.6c0 .13.02.26.02.4M88.02 175.6c0 .13-.02.26-.02.4M96 168c-4.28 0-7.77 3.37-7.98 7.6M88 176c0 4.42 3.58 8 8 8M96 168c4.28 0 7.77 3.37 7.98 7.6M104 176c0 4.42-3.58 8-8 8M104 256c0-.13-.01-.27-.02-.4M88 256c0-.13.01-.27.02-.4M88 256c0 4.42 3.58 8 8 8M88.02 255.6c.21-4.23 3.7-7.6 7.98-7.6M104 256c0 4.42-3.58 8-8 8M103.98 255.6c-.21-4.23-3.7-7.6-7.98-7.6M103.98 335.6c-.21-4.23-3.7-7.6-7.98-7.6M88.02 335.6c.21-4.23 3.7-7.6 7.98-7.6M88.02 335.6c0 .13-.02.26-.02.4 0 4.42 3.58 8 8 8s8-3.58 8-8c0-.13-.01-.27-.02-.4"
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
    />
  </>
);

export default SvgSecure2;
